/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { MobileFactory } from './factory'
import MoreAboutLogic from './logic'

const MoreAboutWrapper = (props: any) => {
  const { layout: { components: { moreAbout = { mobile: 'A' } } = {} } = {} } =
    useHeaderContext()
  const Content = MobileFactory[moreAbout.mobile as keyof typeof MobileFactory]
  return <Content {...props} />
}

const MoreAbout = () => {
  return <MoreAboutLogic Wrapper={MoreAboutWrapper} />
}

export default MoreAbout
